export default function genererCritereRecherche() {
  return {
    auto: '',
    commercialIds: null,
    assistantIds: null,
  };
}
